import { Entity } from '../../entity';
import { JobType } from '../../tenant/job.type';
import { PriorityTiny } from '../../job/priority.tiny';
import { WidgetActionType, WidgetEntity, WidgetType } from './widget.enum';
import { WidgetCardDataFormat } from './widget.type.card';

export interface WidgetDataRequest<TFilter = any> {
    widgetId: string
    widgetTemplateId?: string
    widgetType: WidgetType
    actionType: WidgetActionType
    field: string
    viewId?: string
    filters?: TFilter
    entity: WidgetEntity
}


export interface WidgetData {
    _id: string
    value: number | WidgetData[]
    entity?: Entity | PriorityTiny | JobType | any
    format?: WidgetCardDataFormat;
}

export interface WidgetDataResponse {
    status: 'success' | 'error',
    message?: string;
    data: WidgetData[]
}

export enum WidgetDataResponseStatus {
    SETTING_ERROR = 'SETTING_ERROR',
    NO_PERMISSION = 'NO_PERMISSION'
}